module.exports = __webpack_public_path__ + "img/ico_link-area02.da6692ea.svg";